<template>
  <div class="Gnv">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <div class="yai"></div>
      <el-breadcrumb-item :to="{ path: '/USERS' }">{{ homeName }}</el-breadcrumb-item>
      <el-breadcrumb-item
        v-for="(item, index) in resolvedItems"
        :key="index"
        v-bind="item.to ? { to: item.to } : {}"
      >{{ item.label }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { getMenuAuthName, resolveMenuList } from '@/utils/menuConfig'

/**
 * 面包屑：名称与侧边栏菜单配置同步
 * items: [{ path: 'basicData' }, { path: 'strategy' }]
 * 或非菜单节点: [{ path: 'waterMeterFile', to: '/waterMeterFile' }, { label: '档案详情' }]
 * path 有值时优先用菜单配置中的 authName；label 仅作兜底或菜单外文案
 */
export default {
  name: 'AppBreadcrumb',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    menuList () {
      return resolveMenuList(this.$store.state.print.menuConfig)
    },
    homeName () {
      return getMenuAuthName(this.menuList, 'users') || '项目首页'
    },
    resolvedItems () {
      return (this.items || []).map(item => {
        const path = item && item.path
        const fromMenu = path ? getMenuAuthName(this.menuList, path) : null
        let to = item && item.to
        if (to && typeof to === 'string') {
          to = { path: to }
        }
        return {
          label: fromMenu || (item && item.label) || '',
          to: to || null
        }
      }).filter(item => item.label)
    }
  }
}
</script>

<style lang="less" scoped>
.Gnv {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  font-size: 19px;
  letter-spacing: 1px;
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 75px;
    .yai {
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }
    ::v-deep .el-breadcrumb__item {
      margin-left: 0px;
      .el-breadcrumb__inner.is-link {
        font-weight: 100;
        color: #656d92;
      }
    }
  }
}
@media (max-width: 768px) {
  .Gnv {
    display: none;
  }
}
</style>
